// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__robotoBlack_2a39c8', '__robotoBlack_Fallback_2a39c8'","fontWeight":900},"className":"__className_2a39c8","variable":"__variable_2a39c8"};